var map = {
	"./balance-sign.png": "APW/",
	"./balance-sign.png.png": "6uzM",
	"./contact.png": "h/mT",
	"./content-bg.png": "5yap",
	"./display_off.png": "c7Mt",
	"./display_on.png": "B5So",
	"./electron1.png": "u3Yt",
	"./fishGame1.png": "IEKK",
	"./fishGame2.png": "Zi5e",
	"./fishGame3.png": "05pN",
	"./fishGame4.png": "0y7o",
	"./float-help.png": "/Lo2",
	"./float-line.png": "fuY2",
	"./float-notice.png": "SB0+",
	"./float-phone.png": "0k7v",
	"./float-service.png": "KLlf",
	"./hotGame.png": "Av39",
	"./label-bg.png": "q+uy",
	"./left-bar-bg.png": "vZuW",
	"./logo.png": "APwA",
	"./logo2.png": "xsfR",
	"./lottery-nav-bg.png": "uAEc",
	"./lottery-nav-item-active.png": "6pHJ",
	"./lottery-nav-item.png": "Gg3Q",
	"./lottery-sub-item-base.png": "wX1i",
	"./member.png": "TkfW",
	"./peopleGame1.png": "WAZR",
	"./peopleGame2.png": "HApk",
	"./peopleGame3.png": "1GxJ",
	"./peopleGame4.png": "mg4H",
	"./proxy.png": "7tjN",
	"./ptGame1.png": "9fVl",
	"./ptGame2.png": "wVJX",
	"./ptGame3.png": "V4lx",
	"./ptGame4.png": "g8nb",
	"./ptGame5.png": "CH8E",
	"./ptGame6.png": "99Q4",
	"./qpGame1.png": "FLZe",
	"./reset.png": "eyKs",
	"./right-bar-bg.png": "w9rL",
	"./speaker-container.png": "cfNE",
	"./speaker.png": "OAeq",
	"./sportGame1.png": "vAY9",
	"./sportGame2.png": "u6nr",
	"./sportGame3.png": "7nX1",
	"./sportGame4.png": "VlC5",
	"./user_admin.png": "jqqW",
	"./user_cash.png": "/ztU",
	"./user_exit.png": "dM8o",
	"./user_recharge.png": "bXIo",
	"./user_transfer.png": "paXO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "A3Os";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head ^\.\/.*\.png$
// module id = A3Os
// module chunks = 3